<template>
    <div class="detailcontainer">        
        <div class="content">
           
           <div v-html="conText" class="text">                
           </div>  
           
           <div class="clearfloat"></div>        
        </div> 
        <footBar></footBar>
    </div>
</template>
<script> 
    import footBar from '@/components/footbar' 
    import { bannerlist } from '@/services/api/index'                
    export default {
    name: 'productList',
    computed: {
        bannerId() {
                return this.$route.params.id      
            }
    },
    watch: {
    },
    components: {
        footBar
    },
    data() {
        
        return {           
            conText:''
        }
    },   
    mounted() {
        this.getbanners();
    },
    methods: {
        getbanners(){
            bannerlist().then(res => {
                
                for(var i=0;i<res.data.total;i++){
                    if(res.data.Banners[i].id==this.bannerId){
                        this.conText=res.data.Banners[i].content
                    }
                }
            })
        }
    }
    }
        
</script>
<style rel="stylesheet/scss" lang="scss">
.detailcontainer{
    padding:20px 0 0 0;
    width:100%;    
    background-color:#F6F6F6;
    .content{
        padding:55px;
        text-align: center;           
        margin:0 auto;
        width:1200px;
        min-height:900px;
        /* height:900px;         */
        background-color: #ffffff;
        margin-bottom:20px;
        strong{
            /* margin-bottom:50px; */
            font-size:24px;
        }
        .text{
            text-align:left;
            line-height: 36px;
        }
        .clearfloat{
            clear:both;
            height:0;
            font-size: 1px;
            line-height: 0px;
            }
         img{
            width:500px;
        }
    }
}


</style>


// WEBPACK FOOTER //
// src/components/bannerdetail.vue